import { InjectionToken } from '@angular/core';
import { BackofficeConfigModel } from './shared/api';

export const BASE_BO_CONFIG = new InjectionToken<BackofficeConfigModel>('Backoffice configuration model');
